import styled from 'styled-components';
import Form from '@lt/components/components/Form';

export const Input = styled(Form.Input)`
  text-align: left;

  label div {
    text-transform: uppercase;
    font-size: 9px;
  }

  label > div {
    margin-bottom: 0;
  }

  @media screen and (max-width: 480px) {
    input {
      font-size: 16px;
    }
  }
`;
